import { inject, InjectionToken } from '@angular/core';

import { createSelector, StoreConfig } from '@ngrx/store';

import { ENABLED_INTEGRATION_KINDS, IntegrationKinds } from '@recruitee/integrations-types';
import { createSingleEntityStore, memoizeSelector, SingleEntityState } from '@recruitee/ngrx';

const { actions, namespace, reducer, selectors } = createSingleEntityStore<IntegrationKinds[]>()(
  'enabled-integration-kinds',
);

export const EnabledIntegrationKindsConfigToken = new InjectionToken(
  'EnabledIntegrationKindsConfigToken',
  {
    providedIn: 'root',
    factory: (): StoreConfig<SingleEntityState<IntegrationKinds[]>> => ({
      initialState: {
        loaded: true,
        failed: false,
        pending: false,
        error: false,
        data: inject(ENABLED_INTEGRATION_KINDS),
      },
    }),
  },
);

const enabledIntegrationKindsSelectors = {
  ...selectors,
  hasOne: memoizeSelector((kind: IntegrationKinds) =>
    createSelector(selectors.data, data => (data ? (data.find(k => k === kind) ?? false) : false)),
  ),
};

export {
  actions as EnabledIntegrationKindsActions,
  namespace as EnabledIntegrationKindsNamespace,
  reducer as EnabledIntegrationKindsReducer,
  enabledIntegrationKindsSelectors as EnabledIntegrationKindsSelectors,
};
